var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5496 17.9437C21.0105 17.2104 21.2829 16.3618 21.2829 15.4399C21.2829 12.8314 19.1772 10.7256 16.5686 10.7256C13.96 10.7256 11.8543 12.8314 11.8543 15.4399C11.8543 18.0485 13.96 20.1542 16.5581 20.1542C17.48 20.1542 18.3391 19.8818 19.0619 19.4209L22.3305 22.6895L23.8181 21.2018L20.5496 17.9437ZM16.5686 18.059C15.874 18.059 15.2078 17.783 14.7167 17.2919C14.2255 16.8007 13.9496 16.1345 13.9496 15.4399C13.9496 14.7453 14.2255 14.0792 14.7167 13.588C15.2078 13.0968 15.874 12.8209 16.5686 12.8209C17.2632 12.8209 17.9294 13.0968 18.4205 13.588C18.9117 14.0792 19.1876 14.7453 19.1876 15.4399C19.1876 16.1345 18.9117 16.8007 18.4205 17.2919C17.9294 17.783 17.2632 18.059 16.5686 18.059ZM16.1915 9.15422C15.4162 9.17517 14.6724 9.34279 13.9915 9.62564L13.4153 8.75612L9.43432 15.2304L6.28098 11.5428L2.47813 17.6295L0.770508 16.4037L6.0086 8.02279L9.15146 11.6895L13.3419 4.87993L16.1915 9.15422ZM18.9048 9.67803C18.2343 9.38469 17.5115 9.2066 16.7572 9.16469L22.121 0.689453L23.8181 1.92564L18.9048 9.67803Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatCampaign);
export default __webpack_public_path__ + "static/media/stat-campaign.7bebfa515d5a3ef2e7c727f9b2543b8e.svg";
export { ForwardRef as ReactComponent };